const SQL_TIMEOUT_MS = 8000;

let worker = null;
let requestId = 0;
const pending = new Map();

function stopWorker(reason) {
  if (worker) worker.terminate();
  worker = null;
  for (const request of pending.values()) {
    window.clearTimeout(request.timeout);
    request.reject(new Error(reason));
  }
  pending.clear();
}

function getWorker() {
  if (worker) return worker;
  worker = new Worker(new URL('./sql.worker.js', import.meta.url), { type: 'module' });
  worker.addEventListener('message', (event) => {
    const request = pending.get(event.data.id);
    if (!request) return;
    pending.delete(event.data.id);
    window.clearTimeout(request.timeout);
    if (event.data.ok) request.resolve(event.data.result);
    else request.reject(new Error(event.data.error));
  });
  worker.addEventListener('error', () => stopWorker('The SQL worker stopped unexpectedly.'));
  return worker;
}

export function executeSqlQuery(config, sourceSnapshot) {
  const id = ++requestId;
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      stopWorker('SQL query exceeded the 8 second execution limit.');
    }, SQL_TIMEOUT_MS);
    pending.set(id, { resolve, reject, timeout });
    getWorker().postMessage({ id, config, sourceSnapshot, sql: config.sql.query });
  });
}
